// PatientData Model
import { Model } from '@vuex-orm/core'

export default class PatientEmrTemplate extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'PatientEmrTemplates' 

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id : this.attr(null),
      emr_template_id : this.attr(null),
      emr_template_type : this.attr(null),
      emr_template_status : this.attr(null),
      datas : this.attr(null)

    }
  }
}